import styled from 'styled-components/macro'

const Input = styled.input`
  color: var(--color-gray-90);
  background: var(--color-white);
  border: 1px solid var(--color-gray-20);
  box-sizing: border-box;
  border-radius: var(--border-radius-rounded);
  min-height: var(--size-spacing-07);
  width: 100%;
  padding: 8px 12px;
  border-color: ${props => (props.errorMessage ? 'var(--color-red-50)' : 'var(--color-gray-20)')};

  &:hover {
    border-color: ${props => (props.errorMessage ? 'var(--color-red-50)' : 'var(--color-gray-50)')};
  }

  &:focus,
  &:active {
    border-color: ${props => (props.errorMessage ? 'var(--color-red-50)' : 'var(--color-primary-60)')};
    outline: 0;
  }
`
export default Input
